import styles from './TableCard.module.css';

export default function TableCard({ toolbar, pagination, children }) {
  return (
    <div className={styles.card}>
      {toolbar && <div className={styles.toolbar}>{toolbar}</div>}
      <div className={styles.tableWrapper}>{children}</div>
      {pagination && <div className={styles.pagination}>{pagination}</div>}
    </div>
  );
}
